module.exports = "//public.zight.com/packs/media/images/team_plan_icon-fada4624cd8f95dcf336c4e5431f0a8e.png";